import './DocketList.css';
import { IoMdAdd } from "react-icons/io";
import { CiSearch } from "react-icons/ci";
import { useDocketDetailsLogic } from './Docket_ListLogic';
import { FaEdit } from 'react-icons/fa';
import AddDocketDetailsModal from './AddDocketDetailsModalUI';
const DocketDetails = () => {

    const {
        displayedDockets,
        search,
        setSearch,
        showModal,
        setShowModal, 
        handleEdit,
        selectedDocket, 
        setSelectedDocket,
        fetchDockets,
        dockets
    } = useDocketDetailsLogic();

    return (
        <div className="docket-main-content">

            {/* HEADER */}
            <div className="docket-header">
                <span className="docket-title">Docket Details</span>
                <button onClick={() => setShowModal(true)}>
                    <IoMdAdd /> Add DocketDetails
                </button>
            </div>

            {/* SEARCH */}
            <div className="docket-topbar">
                <div className="docket-search">
                    <CiSearch className="docket-search-icon" />
                    <input
                        type="text"
                        placeholder="Search by Dataset ID"   // changed
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
            </div>

            {/* TABLE */}
            <div className="docket-table-container">
                <table className="docket-table">
                    <thead>
                        <tr>

                            <th>Dataset ID</th>
                            <th>State</th>
                            <th>Docker Image</th>
                            <th>Containers</th>
                            <th>Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {displayedDockets.length === 0 ? (
                            <tr>
                                <td colSpan="5">No Records Found</td>
                            </tr>
                        ) : (
                            displayedDockets.map((d, index) => (
                                <tr key={index}>

                                    <td>{d.dataset_id}</td>
                                    <td>{d.state}</td>
                                    <td>{d.docker_image_path}</td>
                                    <td>{d.container_count}</td>
                                    <td>
                                        <FaEdit
                                            style={{ cursor: "pointer", color: "#09c" }}
                                            onClick={() => handleEdit(d)}
                                        />
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            {showModal && (
                <AddDocketDetailsModal
                    
                  
                onClose={() => {
                    setShowModal(false);
                    setSelectedDocket(null);
                  }}
                  refreshList={fetchDockets}
                  editData={selectedDocket}
                  existingDockets={dockets} />  // 🔥 ADD THIS
            )}
        </div>

    );
};

export default DocketDetails;